import React, { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Lightbox } from './Lightbox';
import { useNavigate } from 'react-router-dom';

// Joni's tattoo portfolio (ready for images)
const joniTattoos = [
  { id: 1, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489276/neo-traditional-black-grey-tattoo-newquay-04_ttdpwj.jpg', alt: 'Neo-traditional black and grey tattoo by Joni Smith - Atlantic Coast Tattoo Newquay Cornwall custom design' },
  { id: 2, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489276/neo-traditional-black-grey-tattoo-newquay-07_liygi9.jpg', alt: 'Traditional black and grey tattoo by Joni Smith - Atlantic Coast Tattoo Cornwall neo-traditional artwork' },
  { id: 3, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489276/neo-traditional-black-grey-tattoo-newquay-13_sl0laq.jpg', alt: 'Japanese traditional tattoo by Joni Smith - Atlantic Coast Tattoo Newquay Cornwall black and grey design' },
  { id: 4, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489275/neo-traditional-black-grey-tattoo-newquay-02_f7t37d.jpg', alt: 'Custom neo-traditional tattoo by Joni Smith - Atlantic Coast Tattoo Cornwall black and grey specialist' },
  { id: 5, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489275/neo-traditional-black-grey-tattoo-newquay-06_z0vz3s.jpg', alt: 'Black and grey traditional design by Joni Smith - Atlantic Coast Tattoo Newquay Cornwall custom work' },
  { id: 6, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489275/neo-traditional-black-grey-tattoo-newquay-09_w7eewe.jpg', alt: 'Neo-traditional tattoo artwork by Joni Smith - Atlantic Coast Tattoo Cornwall black and grey artistry' },
  { id: 7, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489275/neo-traditional-black-grey-tattoo-newquay-16_wwyrcp.jpg', alt: 'Japanese style tattoo by Joni Smith - Atlantic Coast Tattoo Newquay Cornwall traditional black and grey' },
  { id: 8, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489275/neo-traditional-black-grey-tattoo-newquay-19_t8sacx.jpg', alt: 'Traditional black and grey design by Joni Smith - Atlantic Coast Tattoo Cornwall neo-traditional work' },
  { id: 9, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489274/neo-traditional-black-grey-tattoo-newquay-17_xp4flp.jpg', alt: 'Custom traditional tattoo by Joni Smith - Atlantic Coast Tattoo Newquay Cornwall black and grey detail' },
  { id: 10, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489274/neo-traditional-black-grey-tattoo-newquay-18_tzpj4d.jpg', alt: 'Neo-traditional black and grey by Joni Smith - Atlantic Coast Tattoo Cornwall Japanese influenced design' },
  { id: 11, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489274/neo-traditional-black-grey-tattoo-newquay-03_kgb0ey.jpg', alt: 'Black and grey tattoo by Joni Smith - Atlantic Coast Tattoo Newquay Cornwall traditional neo-traditional art' },
  { id: 12, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489274/neo-traditional-black-grey-tattoo-newquay-14_vmzlrv.jpg', alt: 'Japanese traditional tattoo by Joni Smith - Atlantic Coast Tattoo Cornwall neo-traditional black and grey' },
  { id: 13, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489274/neo-traditional-black-grey-tattoo-newquay-05_nhdsn8.jpg', alt: 'Neo-traditional design by Joni Smith - Atlantic Coast Tattoo Newquay Cornwall black and grey custom work' },
  { id: 14, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489273/neo-traditional-black-grey-tattoo-newquay-08_ako8ql.jpg', alt: 'Traditional black and grey tattoo by Joni Smith - Atlantic Coast Tattoo Cornwall Japanese influenced art' },
  { id: 15, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489273/neo-traditional-black-grey-tattoo-newquay-20_u1noez.jpg', alt: 'Black and grey neo-traditional by Joni Smith - Atlantic Coast Tattoo Newquay Cornwall detailed design' },
  { id: 16, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489273/neo-traditional-black-grey-tattoo-newquay-10_glaxmf.jpg', alt: 'Custom traditional tattoo by Joni Smith - Atlantic Coast Tattoo Cornwall black and grey specialist work' },
  { id: 17, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489273/neo-traditional-black-grey-tattoo-newquay-15_wnwbfx.jpg', alt: 'Neo-traditional black and grey by Joni Smith - Atlantic Coast Tattoo Newquay Cornwall custom design' },
  { id: 18, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489273/neo-traditional-black-grey-tattoo-newquay-12_cjkiic.jpg', alt: 'Japanese style tattoo by Joni Smith - Atlantic Coast Tattoo Cornwall traditional black and grey artwork' },
  { id: 19, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1776489273/neo-traditional-black-grey-tattoo-newquay-11_kbvl3c.jpg', alt: 'Traditional neo-traditional tattoo by Joni Smith - Atlantic Coast Tattoo Newquay Cornwall black and grey detail' },
];

// Joni's artwork portfolio (ready for images)
const joniArtwork = [];

const JoniGallery = () => {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeTab, setActiveTab] = useState('tattoos');

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToContact = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const openLightbox = (image) => {
    setSelectedImage(image);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Back Button */}
      <div className="fixed top-24 left-8 z-40">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"
        >
          <ArrowLeft size={20} />
          <span className="text-sm tracking-wider">BACK TO HOME</span>
        </button>
      </div>

      {/* Header */}
      <section className="relative pt-32 pb-12 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="font-display text-4xl md:text-6xl font-bold text-white mb-6">
            JONI'S PORTFOLIO
          </h1>
          <p className="text-xl text-white/80 tracking-wider mb-4">
            Joni Smith
          </p>
          <p className="text-base text-white/70 max-w-3xl mx-auto">
            Specializing in Japanese, Neo-Traditional, Traditional, and Black & Grey styles with 9 years of experience
          </p>
        </div>
      </section>

      {/* Tab Navigation */}
      <section className="py-8 px-4 border-b border-white/20">
        <div className="max-w-7xl mx-auto flex justify-center gap-8">
          <button
            onClick={() => setActiveTab('tattoos')}
            className={`text-3xl tracking-widest pb-2 transition-colors ${
              activeTab === 'tattoos'
                ? 'text-white border-b-2 border-white'
                : 'text-white/60 hover:text-white/80'
            }`}
          >
            TATTOOS
          </button>
          <button
            onClick={() => setActiveTab('artwork')}
            className={`text-3xl tracking-widest pb-2 transition-colors ${
              activeTab === 'artwork'
                ? 'text-white border-b-2 border-white'
                : 'text-white/60 hover:text-white/80'
            }`}
          >
            ARTWORK
          </button>
        </div>
      </section>

      {/* Tattoos Portfolio */}
      {activeTab === 'tattoos' && (
        <section className="py-12 px-4">
          <div className="max-w-7xl mx-auto">
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-white tracking-widest mb-2">
                TATTOO PORTFOLIO
              </h2>
              <p className="text-white/70">
                Completed tattoos showcasing Joni's expertise in Japanese, Neo-Traditional, and Traditional designs
              </p>
            </div>
            {joniTattoos.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {joniTattoos.map((image) => (
                  <div
                    key={image.id}
                    onClick={() => openLightbox(image)}
                    className="relative w-full pb-[100%] overflow-hidden cursor-pointer group"
                  >
                    <img
                      src={image.url}
                      alt={image.alt}
                      loading="lazy"
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <div className="text-center">
                        <p className="text-white text-sm tracking-wider">
                          VIEW FULL SIZE
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-white/60 text-lg">
                  Portfolio coming soon...
                </p>
              </div>
            )}
          </div>
        </section>
      )}

      {/* Artwork Portfolio */}
      {activeTab === 'artwork' && (
        <section className="py-12 px-4">
          <div className="max-w-7xl mx-auto">
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-white tracking-widest mb-2">
                ARTWORK PORTFOLIO
              </h2>
              <p className="text-white/70">
                Original designs, flash sheets, and custom artwork by Joni
              </p>
            </div>
            {joniArtwork.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {joniArtwork.map((image) => (
                  <div
                    key={image.id}
                    onClick={() => openLightbox(image)}
                    className="relative w-full pb-[100%] overflow-hidden cursor-pointer group"
                  >
                    <img
                      src={image.url}
                      alt={image.alt}
                      loading="lazy"
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <div className="text-center">
                        <p className="text-white text-sm tracking-wider">
                          VIEW FULL SIZE
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-white/60 text-lg">
                  Artwork coming soon...
                </p>
              </div>
            )}
          </div>
        </section>
      )}

      {/* Lightbox */}
      <Lightbox
        images={activeTab === 'tattoos' ? joniTattoos : joniArtwork}
        selected={selectedImage}
        onSelect={setSelectedImage}
        onClose={closeLightbox}
      />

      {/* CTA Section */}
      <section className="py-20 px-4 border-t border-white/20">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white tracking-widest mb-6">
            READY TO GET INKED?
          </h2>
          <p className="text-white/80 text-lg mb-8">
            Book a consultation with Joni today
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={scrollToContact}
              className="bg-white text-black px-8 py-4 text-sm tracking-widest hover:bg-gray-200 transition-colors"
            >
              CONTACT US
            </button>
            <a
              href="https://www.instagram.com/joni.smith.tattoo"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white/10 text-white px-8 py-4 text-sm tracking-widest hover:bg-white/20 transition-colors border border-white/30"
            >
              VIEW INSTAGRAM
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default JoniGallery;
